import {AxiosError} from 'axios';
import {store} from 'react-notifications-component';
import {ApiError} from 'types/dtos/ApiError';

export const GlobalNotificationHandler = (err: AxiosError<ApiError>) => {
  store.addNotification({
    title: 'Ошибка!',
    message: `${err.response ? err.response.data.message : err.message}`,
    type: 'danger',
    insert: 'top',
    container: 'bottom-right',
    animationIn: ['animate__animated', 'animate__fadeIn'],
    animationOut: ['animate__animated', 'animate__fadeOut'],
    dismiss: {
      duration: 5000,
      onScreen: true,
    },
  });
};
